import { Base } from "../core/base.model";

export class HorarioLaboralComida extends Base {
  id: number;
  idHorarioLaboralDia: number;
  horaInicio: string | Date;
  horaFin: string | Date;
}

export class HorarioLaboralDia extends Base {
  id: number;
  idHorarioLaboral: number;
  diaSemana: number;
  horaEntrada: string | Date;
  horaSalida: string | Date;
  minutosLaboralesObjetivo: number;
  estatus: string;
  bloquesComida: HorarioLaboralComida[] = [];
}

export class HorarioLaboral extends Base {
  id: number;
  nombre: string;
  descripcion: string;
  estatus: string;
  /**
   * Minutos de gracia propios de la plantilla (0..240). null = usa la
   * tolerancia de Parámetros de asistencia. Hay que mandarlo siempre al
   * guardar: el servidor hace UPDATE de la columna con lo que llegue, y
   * omitirlo borraba la que se capturó en el kiosco.
   */
  minutosTolerancia: number | null;
  fechaCreacion: Date;
  fechaActualizacion: Date;
  dias: HorarioLaboralDia[] = [];
}
